// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDkgSuZNYHiD4Bhnev5A3ESmWKw-_Hk2zA",
  authDomain: "b2e-erp.firebaseapp.com",
  projectId: "b2e-erp",
  storageBucket: "b2e-erp.firebasestorage.app",
  messagingSenderId: "820891226716",
  appId: "1:820891226716:web:ad8686dbf80f60eb494c99",
  measurementId: "G-86R1K9LBP0"
};

// Inicializa o Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Export the app instance
export { firebaseApp };
export const auth = getAuth(firebaseApp);
export const storage = getStorage(firebaseApp);
export const db = initializeFirestore(firebaseApp, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

// Initialize Messaging
export const messaging = getMessaging(firebaseApp);
export { getToken, onMessage };